<template>
  <div class="flex">
    <div class="hidden h-screen w-[35%] bg-neutral-50 md:block">
      <div
        class="ml-[36px] mt-[60px] inline-flex h-[126px] w-[346px] flex-col items-start justify-start gap-4"
      >
        <div class="flex flex-col items-start justify-start gap-2">
          <OrganisationCard />
        </div>
      </div>
    </div>
    <div class="flex h-screen w-full flex-col items-start overflow-scroll px-[6.5%] md:w-[65%]">
      <div class="mt-[60px] inline-flex h-10 w-full items-center justify-start gap-3.5">
        <div class="flex h-10 w-10 items-center justify-center">
          <div class="relative h-10 w-10">
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              :class="`text-${themeColor}-600 fill-current`"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="vuesax/bold/document-sketch">
                <g id="document-sketch">
                  <path
                    id="Vector"
                    d="M34.1667 16.9834H29.3501C25.4001 16.9834 22.1834 13.7667 22.1834 9.81671V5.00004C22.1834 4.08337 21.4334 3.33337 20.5167 3.33337H13.4501C8.31675 3.33337 4.16675 6.66671 4.16675 12.6167V27.3834C4.16675 33.3334 8.31675 36.6667 13.4501 36.6667H26.5501C31.6834 36.6667 35.8334 33.3334 35.8334 27.3834V18.65C35.8334 17.7334 35.0834 16.9834 34.1667 16.9834ZM20.6667 25.9667L17.5667 29.0667C17.1834 29.45 16.6501 29.6667 16.0834 29.6667C15.5167 29.6667 15.0001 29.45 14.6001 29.0667L11.5001 25.9667C10.8167 25.2834 10.7001 24.1334 11.2501 23.3334L12.6667 21.2C13.0167 20.65 13.7501 20.2667 14.4001 20.2667H17.7501C18.4001 20.2667 19.1167 20.65 19.4834 21.2L20.9167 23.3334C21.4334 24.1334 21.3334 25.2834 20.6667 25.9667Z"
                  />
                  <path
                    id="Vector_2"
                    d="M29.0501 14.6833C30.6335 14.6999 32.8335 14.6999 34.7168 14.6999C35.6668 14.6999 36.1668 13.5833 35.5001 12.9166C33.1001 10.4999 28.8001 6.14995 26.3335 3.68328C25.6501 2.99995 24.4668 3.46661 24.4668 4.41661V10.2333C24.4668 12.6666 26.5335 14.6833 29.0501 14.6833Z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div
          v-if="!allComplete"
          class="font-['Inter'] text-lg font-semibold text-black sm:text-xl"
          data-cy="clientPortalTitle"
        >
          Handlung erforderlich
        </div>
        <div
          v-else
          class="font-['Inter'] text-xl font-semibold text-black"
        >
          Abgeschlossen
        </div>
      </div>
      <div
        class="mt-[48px] inline-flex w-[75%] flex-col items-start gap-[13px]"
        data-cy="clientPortalHeading"
      >
        <div>
          <span
            class="font-['Inter'] text-2xl font-semibold tracking-tight text-gray-700 sm:text-3xl"
          >
            {{ greeting }}
          </span>
        </div>
        <div
          v-if="!allComplete"
          class="w-full font-['Inter'] text-sm leading-tight tracking-tight text-gray-700 sm:text-base"
        >
          um mit Ihrer Anfrage weiter fortzufahren, bearbeiten Sie bitte die folgenden Dokumente
          bzw. Fragebögen.
        </div>
        <div
          v-else
          class="w-full font-['Inter'] text-sm leading-tight tracking-tight text-gray-700 sm:text-base"
        >
          prima! Sie haben bereits alle Dokumente bzw. Fragebögen bearbeitet.
        </div>
      </div>
      <div class="mt-[47px] w-full">
        <ClientPortalItems />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import ClientPortalItems from '@/components/clientPortal/clientPortalItems.vue'

  import { computed, onMounted, ref } from 'vue'
  import { useClientActionStore } from '@/store/clientActionStore'
  import OrganisationCard from '@/components/clientPortal/clientPortalOrganisationCard.vue'
  import { useThemeColor } from '@/composables/useThemeColor'

  const clientActionsStore = useClientActionStore()
  const themeColor = computed(() => useThemeColor().value)
  const clientFirstName = computed(() => clientActionsStore.getFirstName)
  const clientLastName = computed(() => clientActionsStore.getLastName)
  const greeting = computed(() => {
    if (clientFirstName.value && clientLastName.value) {
      return `Hallo ${clientFirstName.value} ${clientLastName.value},`
    } else if (clientFirstName.value) {
      return `Hallo ${clientFirstName.value},`
    } else if (clientLastName.value) {
      return `Hallo ${clientLastName.value},`
    }
    return 'Hallo,'
  })

  const allComplete = ref(true)
  const checkAllComplete = () => {
    // Check all submissions
    for (const submission of clientActionsStore.getClientSubmissions) {
      if (submission.state !== 'CLOSED') {
        allComplete.value = false
        break
      }
    }

    // Check all requests if all submissions are complete
    if (allComplete.value) {
      for (const request of clientActionsStore.getClientRequests) {
        if (!request.response) {
          allComplete.value = false
          break
        }
      }
    }
  }

  onMounted(() => {
    checkAllComplete()
  })
</script>
